import { defaultTheme } from 'constants/theme/defaultTheme';
import { ProductThumbProps } from 'features/products/components/ProductThumb/ProductThumb';
import styled from 'styled-components';

const itemWidth = '170px';

export const Styles = {
  Container: styled.div``,
  Button: styled.div`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  `,
  Text: styled.span`
    max-width: ${itemWidth};
  `,
  Image: styled.div`
    width: 100%;
    max-width: ${itemWidth};
    max-height: ${itemWidth};
    height: ${itemWidth};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    margin-bottom: ${defaultTheme.spacing(2)};
    background: ${({ whiteBg }: Pick<ProductThumbProps, 'whiteBg'>) =>
      whiteBg ? defaultTheme.colors.white : defaultTheme.colors.snowGrey};
    img {
      width: auto;
      max-height: 100%;
      mix-blend-mode: multiply;
    }
  `,
};
